import React, { Component } from "react"

/* Components */
import { Chip3D } from "@cuba-go/poker-ui"


/* Component Rates */
class Rates extends Component {

    /* DRAW ANTE */
    _image = () => {

        /* Fields */
        const { ante, chips } = this.props

        /* Check Ante */
        if (ante) {
            return <Chip3D value={ante} chips={chips} size={82} />
        }
    }


    /* DRAW BET */
    _bet = () => {

        /* Fields */
        const { isBet, ante, gameScreen, chips } = this.props

        /* Style */
        const style = gameScreen ? "game" : ""

        /* Bet */
        if (isBet && ante) {
            return (
                <div className={`chip-rate chip-bet ${style}`}>
                    <Chip3D value={ante * 2} size={82} chips={chips} />
                </div>
            )
        }
    }



    /* Draw Bet Result */
    _betResult = () => {

        /* Fields */
        const { result, ante, chips } = this.props

        /* Check Result */
        if (result && result.betMultiplier && parseInt(result.betMultiplier) > 0) {
            return (
                <div className="chip-bet-result-multiplier-box">
                    <div className="chip-bet-result-multiplier-text">{result.betMultiplier}x</div>
                    <div className="chip-bet-result-rate">
                        <Chip3D value={ante * 2 * parseInt(result.betMultiplier)} size={82} chips={chips} />
                    </div>
                </div>
            )
        }

    }


    /* Draw Ante Result */
    _anteResult = () => {

        /* Fields */
        const { result, ante, chips } = this.props

        /* Check Result */
        if (result && result.anteMultiplier && parseInt(result.anteMultiplier) > 0) {
            return (
                <div className="chip-bet-result-multiplier-box">
                    <div className="chip-bet-result-multiplier-text">{result.anteMultiplier}x</div>
                    <div className="chip-bet-result-rate">
                        <Chip3D value={ante} size={82} chips={chips} />
                    </div>
                </div>
            )
        }

    }


    /* Animation Chip when opened */
    _animation = () => {

        /* Fields */
        const { ante, isOpen, half, chips } = this.props

        /* Determine Ante value */
        let final = ante

        if (half) {
            final = ante / 2
        }

        /* Check Open */
        if (isOpen && final) {
            return (
                <div className="chip-open-animation-rate">
                    <Chip3D value={final} size={80} chips={chips} />
                </div>
            )
        }

    }

    /* Chip animations */
    _chipAnimations = () => {

        /* Fields */
        const { history, chips } = this.props

        /* Check History */
        if (history) {
            return (
                <div className="animations">
                    {history.map((animation, index) =>
                        <div className="animated-chip" key={`ANTE-${index}`}>
                            <Chip3D value={animation.value} chips={chips} size={80} />
                        </div>
                    )}
                </div>
            )
        }
    }


    /* Insurance */
    _insurance = () => {

        /* Fields */
        const { insurance, insuranceStatus, chips } = this.props

        /* Insurance Styles */
        let style = "chip-bottom-insurance-title"
        let title = "Страховка"

        if (insuranceStatus === "win") {
            style += " chip-bottom-insurance-success-title"
            title = "Страховка выиграла"
        }

        if (insuranceStatus === "lose") {
            style += " chip-bottom-insurance-fail-title"
            title = "Страховка проиграла"
        }

        /* Check Insurance */
        if (insurance && parseInt(insurance) > 0) {

            /* Determine Status */
            const winInsurance = insuranceStatus === "win" ? insurance * 2 : insurance
            const loseStyle = insuranceStatus === "lose" ? "chip-bottom-insurance-box chip-bottom-insurance-box-lose" : "chip-bottom-insurance-box"

            return (
                <div className="chip-bottom-insurance">

                    <div className={style}>{title}</div>

                    <div className={loseStyle}>
                        <Chip3D value={winInsurance} chips={chips} size={65} />
                    </div>

                    {/* Win Chip */}
                    {insuranceStatus === "win" &&
                        <div className="chip-bottom-insurance-box-win">
                            <Chip3D value={winInsurance} chips={chips} size={65} />
                        </div>
                    }

                </div>
            )
        }
    }


    render = () => {

        /* Fields */
        const { add, ante, isBet, isPass, lose, bet, gameScreen, fromBet, boxStyle, anteAnimatedStyle, betAnimatedStyle } = this.props

        /* Status */
        const style = gameScreen ? "game" : ""
        const betStyle = fromBet ? "blured" : ""
        const anteStyle = (ante && !isPass && !lose) ? "hidden" : ""
        const betHidden = isBet && !lose ? "hidden" : ""
        const isChipsHidden = isPass || lose

        return (
            <div className={`chips-bottom ${style}`}>

                {this._animation()}

                {/* ANTE */}
                {add &&
                    <div onClick={() => add()} className={"chips-bottom-ante"}>

                        <div className="outer-box">
                            <div className={`chips-bottom-ante-click ${anteAnimatedStyle} ${boxStyle}`} />
                        </div>

                        {/* Text */}
                        <div className={`chips-bottom-ante-text ${anteStyle}`}>ANTE</div>

                        {/* Image */}
                        {!isChipsHidden && this._image()}

                        {/* On Add Animation */}
                        {this._chipAnimations()}

                        {/* Result Animation */}
                        {this._anteResult()}

                    </div>
                }

                {/* Rate Bet */}
                <div onClick={() => bet()} className={isBet ? `chips-bottom-bet-click chips-bottom-bet ${style} ${betStyle}` : `chips-bottom-bet ${style} ${betStyle}`}>

                    {/* Box */}
                    <div className={`outer-box ${style} ${betAnimatedStyle}`} />

                    {/* Text */}
                    <div className={`chips-bottom-bet-text ${betHidden}`}>BET</div>

                    {/* Chip */}
                    {!isChipsHidden && this._bet()}

                    {/* Result */}
                    {this._betResult()}

                </div>

                {/* Draw Insurance */}
                {this._insurance()}

            </div>
        )
    }

}

export default Rates